const LinkedIn = () => {
    return (
        <div className="flex cursor-pointer">
            <a href="https://linkedin.com/in/pedros930122" target={"_blank"} rel="noreferrer">
                <img src={'/logo-linkedin.svg'} alt="LinkedIn"className="w-7" />
            </a>
        </div>
    )
}

export default LinkedIn